import {
  SectionWrapper,
  TopFlex,
  TopHeader,
} from 'modules/RuleEngine/Style/style'
import React, { useEffect, useState } from 'react'
import { permittedCruds } from '../../utils/permissionsValidation'
import RuleHeader from './Components/RuleHeader'
import RulesSetTable from './Components/RulesSetTable'

const RuleEngine = ({
  getRuleEngine,
  getRuleSetData,
  ruleSet,
  permissions,
  setUpNewRules,
  deleteRule,
  rulesDegreesMetrics,
}) => {
  useEffect(() => {
    getRuleEngine()
  }, [])

  useEffect(() => {
    setUpNewRules()
  }, [])

  const cruds = permittedCruds(permissions, 'Rule Engine')

  const [state, setState] = useState({
    isRulesSetCourses: false,
    isRulesYetSetCourses: false,
  })

  return (
    <SectionWrapper>
      <TopHeader row spaceBetween alignCenter>
        <TopFlex column>
          <RuleHeader
            state={state}
            setState={setState}
            cardData={rulesDegreesMetrics}
            isDraftRuleExist={ruleSet?.isDraftRuleExist}
            initialState={!rulesDegreesMetrics?.isPublishedRuleExist}
          />
          <RulesSetTable
            data={ruleSet}
            getRuleSetData={getRuleSetData}
            status={1}
            deleteRule={deleteRule}
            emptyState={rulesDegreesMetrics?.isPublishedRuleExist}
            setUpNewRules={setUpNewRules}
          />
        </TopFlex>
      </TopHeader>
    </SectionWrapper>
  )
}

export default RuleEngine
